(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/game-pause-info.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/game-pause-info.js');
'use strict';

const GamePauseInfo = () => React.createElement("section", {
  className: "game-pause-info exclusion-rounded-corners padding-xs-h-2 padding-xs-bottom-2",
  id: "game-pause-info"
}, React.createElement("h3", {
  className: "align-center f-700 f-bold padding-top-2",
  id: "game-pause-info-header"
}, "S\xE5 h\xE4r fungerar spelpaus"), React.createElement("ul", {
  "aria-labelledby": "game-pause-info-header",
  className: "game-pause-info-list",
  tabIndex: "0"
}, React.createElement("li", null, "En spelpaus pausar dig helt och h\xE5llet fr\xE5n spel. Du kan spela igen n\xE4r pausen \xE4r \xF6ver."), React.createElement("li", null, "Svenska Spel kan inte h\xE4va en aktiverad spelpaus. "), React.createElement("li", null, "Du kan alltid ta ut eventuellt saldo genom att g\xE5 till Uttag i h\xF6germenyn."), React.createElement("li", null, "Om du pausat dig i 1 \xE5r eller l\xE4ngre beh\xF6ver du kontakta kundservice f\xF6r att kunna spela igen.")));
svs.selfExclusion.components.GamePauseInfo = GamePauseInfo;

 })(window);